import React from 'react';
import { SvgIconProps, SvgIcon } from '@mui/material';

const RLetter = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 10.6667C12 11.0203 11.8595 11.3594 11.6095 11.6095C11.3594 11.8595 11.0203 12 10.6667 12H1.33333C0.979711 12 0.640573 11.8595 0.390524 11.6095C0.140476 11.3594 0 11.0203 0 10.6667V1.33333C0 0.979711 0.140476 0.640573 0.390524 0.390524C0.640573 0.140476 0.979711 0 1.33333 0L10.6667 0C11.0203 0 11.3594 0.140476 11.6095 0.390524C11.8595 0.640573 12 0.979711 12 1.33333V10.6667Z"
          fill="var(--mui-palette-primary-main)"
        />
        <path
          d="M3.59375 3.11398C3.59375 2.61798 3.87275 2.30798 4.38975 2.30798H6.20875C7.80042 2.30798 8.78208 3.02132 8.78208 4.64365C8.78208 5.78065 7.92442 6.43165 6.87008 6.59698L8.62742 8.47832C8.77175 8.63332 8.83375 8.78832 8.83375 8.93298C8.83375 9.33598 8.51342 9.72865 8.05908 9.72865C7.87275 9.72865 7.62475 9.65632 7.45942 9.45998L5.16508 6.67965H5.14442V8.92232C5.14442 9.43932 4.81375 9.72832 4.36908 9.72832C3.92442 9.72832 3.59375 9.43932 3.59375 8.92232V3.11398ZM5.14408 5.56332H6.20842C6.77675 5.56332 7.16975 5.22232 7.16975 4.64365C7.16975 4.05465 6.77642 3.73398 6.20842 3.73398H5.14408V5.56332Z"
          fill="var(--mui-palette-common-white)"
        />
      </svg>
    </SvgIcon>
  );
};

export default RLetter;
